import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const pricingPlanClasses = generateUtilityClasses('AFPricingPlan', [
  'content',
  'mostPopular',
  'title',
  'pricingContainer',
  'total',
  'description',
  'planContent',
  'action'
]);
